import { Control } from 'ol/control';
import GIS from "../app"
import {LayerType, Toggle} from "../configuration/layer";
import {ToggleOptions} from "../configuration/control";

class ToggleControl extends Control {
    private readonly GIS;
    private layer;
    private readonly topButtonsGroup;
    private readonly topButtonsGroupWrapper;

    constructor(options: ToggleOptions, GIS: GIS) {
        const element = document.createElement('div');

        super({
            element: element,
            target: options.target,
        });

        this.GIS = GIS;

        this.layer = document.createElement('button');
        this.layer.type = 'button';

        this.topButtonsGroup = document.createElement('div');
        this.topButtonsGroup.id = 'top-buttons-group';

        this.topButtonsGroupWrapper = document.createElement('div');
        this.topButtonsGroupWrapper.className = "top-buttons-group-wrapper";

        this.topButtonsGroup.appendChild(this.topButtonsGroupWrapper);

        options.layers.forEach((layer:string) => this.createButton(layer));

        element.className = 'cfm-tool cfm-toggle ol-unselectable ol-control';
        element.appendChild(this.topButtonsGroup);
    }

    public createButton(layer: string) {
        const olLayer = this.GIS.Layer.getLayer(layer) as LayerType & Toggle;
        let visible = olLayer.getVisible();

        const button = document.createElement('button');
        button.type = 'button';
        button.className = visible ? 'active' : '';
        const switcher = olLayer.get('switcher') ?? {};
        this.GIS.Localisation.bindLazy(
            t => { button.innerText = t; },
            () => (olLayer.get('switcher') as { i18n?: { title?: Record<string, string> } } | undefined)?.i18n?.title,
            switcher.title ?? layer
        );

        const deactivateToggle = () => {
            button.className = '';
        };

        const activateToggle = () => {
            button.className = 'active';
        };

        const setVisibility = () => {
            visible = olLayer.getVisible();
            this.GIS.Layer.setLayerVisibility(layer, !visible);
        }

        olLayer.toggle = true;
        olLayer.deactivateToggle = deactivateToggle;
        olLayer.activateToggle = activateToggle;

        button.addEventListener('click', setVisibility, false);

        this.topButtonsGroupWrapper.appendChild(button);
    }
}

export default ToggleControl;